import {ThreeDotVerticalIcon} from "../../react/components/Icons";
import ButtonIconTooltip from "../ButtonIconTooltip";

import {useDefaultTrigger} from "./useDefaultTrigger";

interface Props {
    testID?: string;
    placement?: "left" | "right";
    isLoading?: boolean;
}

export function useThreeDotsTrigger({testID, placement, isLoading, ...props}: Props = {}) {
    return useDefaultTrigger(
        <ButtonIconTooltip
            isLoading={isLoading}
            placement={placement ?? "left"}
            size="md"
            testID={testID ?? "btn-more-menu"}
            tooltip="More options"
            {...props}
            icon={ThreeDotVerticalIcon}
        />,
        true
    );
}
